import { IAction } from '~/src/store';

import { EChangePaymentDateActions } from './index';

export type TLoadingStatus = 'success' | 'error' | 'none';

export type TSetLoadingDayInfoStatus = IAction<EChangePaymentDateActions.SET_LOADING_DAY_INFO_STATUS, TLoadingStatus>

const setLoadingDayInfoStatus = (status: TLoadingStatus): TSetLoadingDayInfoStatus => ({
    type: EChangePaymentDateActions.SET_LOADING_DAY_INFO_STATUS,
    payload: status,
});

export default setLoadingDayInfoStatus;
